import * as Types from '../../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetStartPageJwtvModulesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	platform?: Types.Platform;
	profile?: Types.InputMaybe<Types.PosterProfile>;
	format?: Types.InputMaybe<Types.ImageFormat>;
}>;

export type GetStartPageJwtvModulesQuery = {
	__typename?: 'Query';
	MAIN_TOP_10_MOVIES: {
		__typename: 'PopularTitlesConnection';
		edges?: Array<{
			__typename?: 'PopularTitlesEdge';
			cursor: string;
			node:
				| {
						__typename: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						content: {
							__typename?: 'MovieContent';
							title: string;
							fullPath: string;
							posterUrl?: string | null;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							scoring: { __typename?: 'Scoring'; imdbScore?: number | null; jwRating?: number | null };
						};
						watchNowOffer?: {
							__typename?: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								icon: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| {
						__typename: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						content: {
							__typename?: 'ShowContent';
							title: string;
							fullPath: string;
							posterUrl?: string | null;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							scoring: { __typename?: 'Scoring'; imdbScore?: number | null; jwRating?: number | null };
						};
						watchNowOffer?: {
							__typename?: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								icon: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  };
		}> | null;
	};
	MAIN_TOP_10_SHOWS: {
		__typename: 'PopularTitlesConnection';
		edges?: Array<{
			__typename?: 'PopularTitlesEdge';
			cursor: string;
			node:
				| {
						__typename: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						content: {
							__typename?: 'MovieContent';
							title: string;
							fullPath: string;
							posterUrl?: string | null;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							scoring: { __typename?: 'Scoring'; imdbScore?: number | null; jwRating?: number | null };
						};
						watchNowOffer?: {
							__typename?: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								icon: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| {
						__typename: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						content: {
							__typename?: 'ShowContent';
							title: string;
							fullPath: string;
							posterUrl?: string | null;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							scoring: { __typename?: 'Scoring'; imdbScore?: number | null; jwRating?: number | null };
						};
						watchNowOffer?: {
							__typename?: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								icon: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  };
		}> | null;
	};
};

export const GetStartPageJwtvModulesDocument = gql`
	query GetStartPageJwtvModules(
		$country: Country!
		$language: Language!
		$platform: Platform! = WEB
		$profile: PosterProfile
		$format: ImageFormat
	) {
		MAIN_TOP_10_MOVIES: popularTitles(
			country: $country
			language: $language
			first: 10
			sortBy: TRENDING
			filter: {
				objectTypes: [MOVIE]
				excludeIrrelevantTitles: false
				genres: []
				excludeEroticAvodHack: true
				experiment: "EXP_START_PAGE_JWTV"
				monetizationTypes: [FREE, ADS]
			}
		) {
			__typename
			edges {
				cursor
				node {
					... on MovieOrShow {
						__typename
						id
						objectId
						objectType
						content(country: $country, language: $language) {
							title
							fullPath
							posterUrl(profile: $profile, format: $format)
							originalReleaseYear
							runtime
							scoring {
								imdbScore
								jwRating
							}
						}
						watchNowOffer(country: $country, platform: $platform) {
							id
							standardWebURL
							preAffiliatedStandardWebURL
							package {
								id
								packageId
								clearName
								shortName
								technicalName
								icon
								iconWide(profile: S160)
								hasRectangularIcon(country: $country, platform: WEB)
							}
							presentationType
							monetizationType
						}
					}
				}
			}
		}
		MAIN_TOP_10_SHOWS: popularTitles(
			country: $country
			language: $language
			first: 10
			sortBy: TRENDING
			filter: {
				objectTypes: [SHOW]
				excludeIrrelevantTitles: false
				genres: []
				excludeEroticAvodHack: true
				experiment: "EXP_START_PAGE_JWTV"
				monetizationTypes: [FREE, ADS]
			}
		) {
			__typename
			edges {
				cursor
				node {
					... on MovieOrShow {
						__typename
						id
						objectId
						objectType
						content(country: $country, language: $language) {
							title
							fullPath
							posterUrl(profile: $profile, format: $format)
							originalReleaseYear
							runtime
							scoring {
								imdbScore
								jwRating
							}
						}
						watchNowOffer(country: $country, platform: $platform) {
							id
							standardWebURL
							preAffiliatedStandardWebURL
							package {
								id
								packageId
								clearName
								shortName
								technicalName
								icon
								iconWide(profile: S160)
								hasRectangularIcon(country: $country, platform: WEB)
							}
							presentationType
							monetizationType
						}
					}
				}
			}
		}
	}
`;
